export default function Transformation() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-40 bg-slate-50 relative overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/d96c8844ae91b4c447a1a65f4af2552b.jpg"
          alt="Transformation Background"
          className="w-full h-full object-cover opacity-10"
        />
      </div>

      <div className="max-w-[900px] mx-auto px-20 text-center relative z-10">
        <h2 className="text-6xl font-extrabold text-slate-900 mb-10 leading-tight">
          From Uncertainty to Intelligent Clarity
        </h2>

        <div className="space-y-6 mb-14">
          <p className="text-2xl text-slate-600 leading-relaxed">
            Organizations that succeed with AI don't chase trends.
          </p>
          <p className="text-2xl text-slate-600 leading-relaxed">
            They follow direction.
          </p>
          <p className="text-xl text-slate-600 leading-relaxed mt-8">
            NorthStar Innovations AI provides the structure, guidance, and system intelligence that turns AI into a competitive advantage — not a risk.
          </p>
        </div>

        <button
          onClick={() => scrollToSection('final-cta')}
          className="px-10 py-5 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-all duration-200 text-lg font-medium cursor-pointer whitespace-nowrap shadow-lg"
        >
          Begin Your AI Roadmap
        </button>
      </div>
    </section>
  );
}
